const SocietyFinalistBooth = () => import(/* webpackChunkName: "SocietyFinalistBooth" */ '@/components/Pages/SocietyFinalistBooth')
const BroadcomFoundationBooth = () => import(/* webpackChunkName: "BroadcomFoundationBooth" */ '@/components/Pages/BroadcomFoundationBooth')

module.exports = [
  {
    path: '/:partner?/broadcom-foundation-booth',
    name: 'broadcomfoundationbooth',
    component: BroadcomFoundationBooth
  },
  {
    path: '/:partner?/finalist-booth/:id',
    name: 'iseffinalistbooth',
    component: SocietyFinalistBooth
  }
]
